import React, { useState } from "react";

import { Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import TinyEditor from "../../../../components/Editor";
import { ISiteSettingsForm } from "../../../../types/forms";

const SiteNotice = (): React.JSX.Element | undefined => {
    const methods = useFormContext<ISiteSettingsForm>();
    const [editorValue, setEditorValue] = useState<string>(
        methods.getValues("siteNotice") || "",
    );

    const watchNotice = methods.watch(
        "siteNotice",
        methods.getValues("siteNotice"),
    );

    return (
        <section className="siteSettingsNoticeContent">
            <Row>
                <Col>
                    <h6 style={{ marginTop: "10px" }}>
                        Site notice will automatically display until midnight of
                        the current day as long as there is a notice set in the
                        text editor below.
                        <br />
                        To clear the notice early, clear all content in the text
                        editor and click the "Update Settings" button.
                    </h6>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    <Form.Control
                        type="hidden"
                        {...methods.register("siteNotice", {
                            value: watchNotice
                                ? "true"
                                : methods.getValues("siteNotice") ||
                                  editorValue,
                        })}
                    />
                    <TinyEditor
                        editorValue={editorValue}
                        showSave={false}
                        formField="siteNotice"
                        formMethods={methods}
                        setEditorValue={setEditorValue}
                    />
                </Col>
            </Row>
        </section>
    );
};

export default SiteNotice;
